import React, { useState } from 'react';
import './App.css';
import Index from './Home'
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Terms from './Terms';
import AboutUs from './AboutUs';
import Privacy from './Privacy';
import { UI_COACHING, UI_TEST, UI_RESULT, UI_ORG_STATS, UI_USER_ADMIN } from './consts';
import ReactGA from "react-ga4";
import { GA_ID } from './consts';
import SignIn from './SignIn'
import SignUp from './SignUp';
import SelfService from './SelfService';
import Coaching from './Coaching';
import Pricing from './Pricing';
import Exam from './Exam';
import ExamResult from './ExamResult';
import ExamResultOfOrg from './ExamResultOfOrg';
import UserAdmin from './UserAdmin';
import { LanguageProvider } from './contexts/LanguageContext';
import Koukoku from './Koukoku';

ReactGA.initialize(GA_ID);

const App = () => {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path={`/`} element={<Index />} />
          <Route path={`/sign-in/`} element={<SignIn />} />
          <Route path={`/sign-up/`} element={<SignUp />} />
          <Route path={`/account/`} element={<SelfService />} />
          <Route path={`/about/`} element={<AboutUs />} />
          <Route path={UI_COACHING} element={<Coaching />} />
          <Route path={UI_TEST} element={<Exam />} />
          <Route path={UI_RESULT} element={<ExamResult />} />
          <Route path={UI_ORG_STATS} element={<ExamResultOfOrg />} />
          <Route path={UI_USER_ADMIN} element={<UserAdmin />} />
          <Route path={`/pricing/`} element={<Pricing />} />
          <Route path={`/terms`} element={<Terms />} />
          <Route path={`/privacy`} element={<Privacy />} />
          <Route path={`/investor-relations/financial-statements/`} element={<Koukoku />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
};

export default App;
